import { render, staticRenderFns } from "./databank.vue?vue&type=template&id=4b76ab03&"
import script from "./databank.vue?vue&type=script&lang=js&"
export * from "./databank.vue?vue&type=script&lang=js&"
import style0 from "./databank.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports